export default __webpack_public_path__ + "static/media/settings.aa276be0.svg";